import { render } from "./HostAdd.vue?vue&type=template&id=00a81c74"
import script from "./HostAdd.vue?vue&type=script&lang=js"
export * from "./HostAdd.vue?vue&type=script&lang=js"

import "./HostAdd.vue?vue&type=style&index=0&id=00a81c74&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos7-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.1.2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__